function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:url(#BlueGradient);}.cls-2{fill:#fff;}"), React.createElement("linearGradient", {
  id: "BlueGradient",
  x1: -897.47,
  y1: -41.53,
  x2: -1003.54,
  y2: 64.54,
  gradientTransform: "translate(-913 49) rotate(180)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#2e27ad"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#527fff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-RDS");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Blue_Gradient",
  "data-name": "Blue Gradient",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Icon_Test",
  "data-name": "Icon Test"
}, React.createElement("path", {
  className: "cls-2",
  d: "M48.45,28.23c0-2.9-5.69-4.24-11-4.24s-11,1.34-11,4.24a1.49,1.49,0,0,0,.05.43V46.71c-.05,3,5.65,4.28,11,4.28s11-1.32,11-4.22V28.23ZM37.47,26c5.83,0,9,1.59,9,2.24s-3.15,2.24-9,2.24-9-1.58-9-2.24S31.64,26,37.47,26Zm9,20.78c0,.64-3.16,2.22-9,2.22s-9-1.58-9-2.22V43.62c2.11,1.15,5.65,1.7,9,1.7s6.86-.54,9-1.67Zm0-5.69c0,.64-3.15,2.24-9,2.24s-9-1.6-9-2.24H28.5V37.27c2.11,1.14,5.65,1.69,9,1.69s6.86-.54,9-1.67Zm0-6.37c0,.65-3.15,2.25-9,2.25s-9-1.6-9-2.25H28.5V30.82c2.13,1.13,5.63,1.65,9,1.65s6.91-.54,9-1.69Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M15.91,60.51H22.5v2h-9a1,1,0,0,1-1-1v-9h2v6.57L22,51.59,23.4,53Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,52.51v9a1,1,0,0,1-1,1h-9v-2h6.59L51.7,53.1l1.41-1.4,7.39,7.38V52.51Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,13.51v9h-2v-6.6L53.11,23.3,51.7,21.89l7.38-7.38H52.5v-2h9A1,1,0,0,1,62.5,13.51Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M23.4,22,22,23.4,14.5,15.91v6.58h-2v-9a1,1,0,0,1,1-1h9v2H15.91Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M22.16,46.46c-6.11-2.2-9.61-5.56-9.61-9.21s3.5-7,9.61-9.21l.68,1.88c-5.19,1.87-8.29,4.61-8.29,7.33s3.1,5.46,8.29,7.33Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M52.28,46.68l-.64-1.9c5.55-1.87,8.86-4.69,8.86-7.53s-3.31-5.66-8.86-7.54l.64-1.89C58.77,30,62.5,33.46,62.5,37.25S58.77,44.48,52.28,46.68Z"
})));

var SvgAwsRds = function SvgAwsRds(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsRds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-RDS.6d397afa.svg";
export { ForwardRef as ReactComponent };